import React from 'react';
import { Skeleton, Typography } from '@mui/material';
import { usePipelineContext } from '@/context/pipelineContext';
import { DEAL_STATUS_TYPES } from '@/utils/constants';

const DataGridDealStage = ({ pipeline, dealStage, status }) => {
	const { stages, isLoading: isPipelineLoading } = usePipelineContext(pipeline);

	const currentStage = stages?.find((stage) => stage.stageId === dealStage)?.label;

	const isArchived = status === DEAL_STATUS_TYPES.archived;
	const stageLabel = isArchived ? 'Archived' : (currentStage ?? dealStage ?? 'Unknown');

	return isPipelineLoading ? (
		<Skeleton variant='text' width='5em' />
	) : (
		<Typography variant='inherit'>{stageLabel}</Typography>
	);
};

export default DataGridDealStage;
